import styles from "./styles.module.scss";
import { Outlet } from "react-router";
import { useHook } from "./useHook";
import {
  circadiaEngineProvider,
  localStorageProvider,
} from "../../AppController";
import { AppErrorBoundary } from "../../components/CustomComponents/PageErrorBoundry";
import { ErrorComponent } from "../../components/CustomComponents/PageErrorBoundry/ErrorComponent";
import { useMobileTopBottomColor } from "../../hooks/useMobileTopBottomColor";
import { isPIN } from "../../util/pin";

const PublicLayout = () => {
  useMobileTopBottomColor({
    circadiaEngineProvider: circadiaEngineProvider,
  });
  const { uniquePageKey } = useHook({ localStorageProvider, isPIN });
  return (
    <div className={styles.app}>
      <div className={styles.body}>
        <AppErrorBoundary
          FallbackComponent={({ error, resetErrorBoundary }) => (
            <ErrorComponent
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          )}
          resetKeys={[uniquePageKey]}
        >
          <Outlet />
        </AppErrorBoundary>
      </div>
    </div>
  );
};

export default PublicLayout;
